import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { BrowserRouter, useRoutes, Navigate } from 'react-router-dom';
import MonitorPage from './MonitorPage';
import LoginPage from './LoginPage';
import ResultPage from './ResultPage';
import InvitationPage from './InvitationPage';

import SettingsBars from './SettingsBars';
import { Flex } from './shared/Flex';
import { useCameras, useDisableZoom } from '../hooks';
import UAParser from 'ua-parser-js';

const Container = styled(Flex)<{ isSettingsOpen: boolean }>`
  height: 100%;
  width: 100%;
  position: relative;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: ${({ isSettingsOpen }) =>
    isSettingsOpen && 'rgba(0, 0, 0, 0.5)'};
`;
const PrivateRoute = ({ children }) => {
  const jwt = sessionStorage.getItem('acrossToken');
  const code = sessionStorage.getItem('code');
  
  return jwt||code ? children : <Navigate to="/login" />;
};
const App = () => {
  
  const [isLicenseValid, setIsLicenseValid] = useState(false);
  const [isDevice] = useState(
    UAParser(navigator.userAgent).device.type,
  );
  const [isMobile] = useState(
    UAParser(navigator.userAgent).device.type === 'mobile',
  );
  useDisableZoom();

  useEffect(() => {
    //const jwt = sessionStorage.getItem('acrossToken');
    //console.log("jwt"+jwt);

  }, []);

  const updateLicenseStatus = useCallback((valid) => {
    setIsLicenseValid(valid);
  }, []);

  const routes = useRoutes([
    {
      path: '/login',
      element: <LoginPage/>
    },
    {
      path: '/invitation',
      element: <InvitationPage/>
    },
    {
      path: '/monitor',
      element: (
        <PrivateRoute>
          <MonitorPage/>
        </PrivateRoute>
      )
    },
    {
      path: '/result',
      element: (
        <PrivateRoute>
          <ResultPage/>
        </PrivateRoute>
      )
    },
    {
      path: '/',
      element: <Navigate to="/login" />
    }
  ]);
  return (
    <Container isSettingsOpen={false}>
      {routes}
    </Container>
  );
  // return (
  //   <Container isSettingsOpen={isSettingsOpen}>
  //     <Routes>
  //         <Route path="/login" element={<LoginPage />} />
  //         <Route
  //           path="/monitor"
  //           element={
  //             <PrivateRoute>
  //               <BinahMonitor
  //                 showMonitor={!(isMobile && isSettingsOpen)}
  //                 cameraId={cameraId}
  //                 onLicenseStatus={updateLicenseStatus}
  //                 onSettingsClick={toggleSettingsClick}
  //                 isSettingsOpen={isSettingsOpen}
  //               />
  //               <SettingsBars
  //                 open={isSettingsOpen}
  //                 onClose={handleCloseSettings}
  //                 cameras={cameras}
  //                 isLicenseValid={isLicenseValid}
  //               />
  //             </PrivateRoute>
  //           }
  //         />
  //       </Routes>
  //   </Container>
  // );
};

export default App;
